import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Map as MapIcon } from "lucide-react";
import { api } from "../../lib/api";
import MapView from "../MapView";

export default function MapPreview() {
  const [places, setPlaces] = useState([]);
  useEffect(() => { api.get("/places", { params: { } }).then(r => setPlaces(r.data)).catch(()=>{}); }, []);

  return (
    <section className="px-4 sm:px-6 max-w-7xl mx-auto" data-testid="map-preview-section">
      <div className="flex items-end justify-between mb-5">
        <div>
          <div className="uppercase-label text-[#00A6B3] flex items-center gap-1.5"><MapIcon size={12}/> Carte interactive</div>
          <h2 className="font-display font-black text-2xl sm:text-3xl tracking-tighter text-[#1A1A1A] mt-1">
            L'île à portée de doigt
          </h2>
        </div>
        <Link to="/map" data-testid="open-full-map" className="flex items-center gap-1.5 text-sm font-bold text-[#00A6B3] hover:underline">
          Ouvrir la carte <ArrowUpRight size={14}/>
        </Link>
      </div>
      <Link to="/map" className="block relative rounded-3xl overflow-hidden border border-black/5 shadow-md group" data-testid="map-preview-link">
        <div className="h-[280px] sm:h-[360px] pointer-events-none">
          <MapView places={places} interactive={false} zoom={9}/>
        </div>
        <div className="absolute inset-0 bg-gradient-to-tr from-black/30 via-transparent to-transparent group-hover:from-black/10 transition-colors flex items-end p-5">
          <div className="bg-white/95 backdrop-blur-md rounded-2xl px-4 py-3 shadow-lg flex items-center gap-3 group-hover:scale-105 transition-transform">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#00A6B3] to-[#2EC4B6] text-white flex items-center justify-center">
              <MapIcon size={18}/>
            </div>
            <div>
              <div className="font-display font-bold text-[#1A1A1A]">Voir tous les spots</div>
              <div className="text-xs text-[#1A1A1A]/60">{places.length} adresses sur la carte</div>
            </div>
            <ArrowUpRight size={18} className="text-[#1A1A1A]/40 ml-2"/>
          </div>
        </div>
      </Link>
    </section>
  );
}
